import { CircularProgress, createTheme, Dialog, DialogContent, Grid, ThemeProvider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { GetAdminSettingValue } from "../../../api";
import { GetLicenseName } from "../../../api/PE_API";

//Update log
//
//FB 7969  DK  12/20/2023    Add privacy policy link and content on Portal

export default function PrivacyPolicy() {
    const [practice, setPractice] = useState({ name: "", phone: "" });
    const [showSpinner, setShowSpinner] = useState(false);
    const theme = createTheme({
        palette: {
            primary: {
                main: "#083A4D",
            },
        },
        components: {
            MuiDialog: {
                defaultProps: {
                    onClick: (e) => e.stopPropagation(),
                    BackdropProps: {
                        sx: {
                            pointerEvents: "none",
                        },
                    },
                },
            },
        },
    });

    async function GetPracticeInfo() {
        let session = sessionStorage.getItem("Practice");
        if (session == null || session == undefined) {
            var name = await GetLicenseName();
            var phone = await GetAdminSettingValue("Practice_Phone");
            sessionStorage.setItem("Practice", JSON.stringify({ name: name, phone: phone }));
            setPractice({ name: name, phone: phone });
        } else {
            setPractice(JSON.parse(session));
        }
    }

    useEffect(() => {
        setShowSpinner(true);
        GetPracticeInfo();
    }, []);

    useEffect(() => {
        if (practice.name != "") {
            setShowSpinner(false);
        }
    }, [practice])


    return (<>
        <Grid container spacing={2}
        // style={{ display: "flex", justifyContent: "center", alignContent: "center" }}
        >
            <Grid item xs={12} style={{textAlign:"justify"}}
            // style={{ display: "flex", justifyContent: "center", alignContent: "center" }}
            >
                <Typography variant="subtitle1">
                    <br />
                    At <b>{practice.name}</b>, we are committed to protecting the privacy and confidentiality of our patients' personal information. This privacy policy outlines the procedures and practices regarding the collection, use, disclosure, and protection of patient information within our patient portal.
                    <br /><br />
                    <b>Information Collection and Use:</b>
                    <br />
                    We collect personal information, including but not limited to, name, contact information, medical history, and insurance details, to provide healthcare services and facilitate communication between patients and healthcare providers.
                    The information collected is used for the purpose of treatment, payment, and healthcare operations, in accordance with applicable laws and regulations.
                    <br /><br />
                    <b>Information Disclosure:</b>
                    <br />
                    Patient information is disclosed, as necessary, to healthcare providers and personnel involved in the provision of care. This includes scheduling appointments, processing insurance claims, and coordinating treatment.
                    Disclosure of patient information may also occur as required by law, court order, or governmental regulations.
                    <br /><br />
                    <b>Data Security:</b>
                    <br />
                    We employ industry-standard security measures to protect patient information from unauthorized access, disclosure, alteration, or destruction.
                    Access to patient information is restricted to authorized personnel with a legitimate need for accessing the information.
                    <br /><br />
                    <b>Data Retention and Disposal:</b>
                    <br />
                    Patient information is retained for the period necessary to fulfill the purposes outlined in this privacy policy and as required by law and regulations. When no longer required, information is securely disposed of to prevent unauthorized access.
                    <br /><br />
                    <b>Patient Rights:</b>
                    <br />
                    Patients have the right to access their personal information, request corrections, and obtain an account of information disclosures.
                    Patients have the right to request restrictions on the use and disclosure of their information subject to legal and contractual obligations.
                    <br /><br />
                    <b>Changes to Privacy Policy:</b>
                    <br />
                    This privacy policy may be updated periodically to reflect changes in our information practices. Patients will be notified of significant changes and are encouraged to review the policy periodically.
                    <br /><br />
                    <b>Contact Information:</b>
                    <br />
                    For questions or concerns regarding this privacy policy, please contact <b>{practice.phone}</b>.
                </Typography>
            </Grid>
        </Grid>
        <ThemeProvider theme={theme}>
            <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
                <DialogContent
                    style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress style={{ color: "#083A4D" }} />
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    </>
    )
}